export const CHALLENGE_URL = "https://i151.djamma.dev/challenge";
